import { render, staticRenderFns } from "./Search_author.vue?vue&type=template&id=13b596ed&scoped=true&"
import script from "./Search_author.vue?vue&type=script&lang=js&"
export * from "./Search_author.vue?vue&type=script&lang=js&"
import style0 from "./Search_author.vue?vue&type=style&index=0&id=13b596ed&scoped=true&lang=css&"
import style1 from "./Search_author.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b596ed",
  null
  
)

export default component.exports